export function openTermsAndConditionsPageInNewTab(): void {
    window.open('https://www.pidedirecto.mx/terminos-y-condiciones', '_blank');
}
